import { Button, colors, Modal, ModalActions, ModalHeader, Typography } from '@ui-components/neo.tax';
import { ReactComponent as AlarmBellRing } from '@ui-components/neo.tax/dist/icons/alarm-bell-ring.svg';

import { evictCache } from '@neo.tax/shared';

import { useUnlinkTicketingProviderUserFromRdTaxCreditContributor } from './hooks';

type UnlinkTicketingProviderUserFromPayrollExpenseModalProps = {
  isOpen: boolean;
  onClose: () => void;
  rdTaxCreditContributorId: string;
  ticketingProviderUserId: string;
};

export const UnlinkTicketingProviderUserFromRdTaxCreditContributorModal = ({
  isOpen,
  onClose,
  rdTaxCreditContributorId,
  ticketingProviderUserId,
}: UnlinkTicketingProviderUserFromPayrollExpenseModalProps): React.ReactElement => {
  const [unlinkTicketingProviderUserFromRdTaxCreditContributor, { loading }] =
    useUnlinkTicketingProviderUserFromRdTaxCreditContributor();
  const handleCancel = (): void => {
    onClose();
  };

  const handleConfirm = async (): Promise<void> => {
    await unlinkTicketingProviderUserFromRdTaxCreditContributor({
      variables: {
        rdTaxCreditContributorId,
        ticketingProviderUserId,
      },
      awaitRefetchQueries: true,
      refetchQueries: ['GetPayrollQres', 'GetTicketingUsers'],
      update: (cache) => {
        evictCache(cache, ['getPayrollExpense']);
      },
    });
    onClose();
  };

  return (
    <Modal isOpen={isOpen}>
      <ModalHeader
        icon={<AlarmBellRing width={24} color={colors.blue[600]} />}
        iconBgColor={colors.blue[50]}
        title={
          <Typography fontSize="base" fontWeight="semibold">
            Unlink Associated Ticketing Account?
          </Typography>
        }
        copy="This may change R&D allocations for this payroll record."
      />
      <ModalActions hasTopBorder={false}>
        <Button disabled={loading} variant="white" rounded="regular" size="base" onClick={handleCancel}>
          Cancel
        </Button>
        <Button
          disabled={loading}
          isLoading={loading}
          variant="primary"
          rounded="regular"
          size="base"
          onClick={handleConfirm}
        >
          Unlink
        </Button>
      </ModalActions>
    </Modal>
  );
};
